var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkP500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark_p500"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    width: 18,
    height: 18,
    rx: 9,
    fill: "#2CAD5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6 Copy",
    d: "M4 9.0303L7.48333 12.3889L13.5 5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkP500);
export default __webpack_public_path__ + "static/media/checkmark_p500.a309f5dbcb37261326e2e97c067dc74a.svg";
export { ForwardRef as ReactComponent };